import { render, staticRenderFns } from "./ETACdetail.vue?vue&type=template&id=fa03f2b6&scoped=true"
import script from "./ETACdetail.vue?vue&type=script&lang=js"
export * from "./ETACdetail.vue?vue&type=script&lang=js"
import style0 from "./ETACdetail.vue?vue&type=style&index=0&id=fa03f2b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa03f2b6",
  null
  
)

export default component.exports